import { render, staticRenderFns } from "./recruit.vue?vue&type=template&id=64508f6e&scoped=true"
import script from "./recruit.vue?vue&type=script&lang=js"
export * from "./recruit.vue?vue&type=script&lang=js"
import style0 from "./recruit.vue?vue&type=style&index=0&id=64508f6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64508f6e",
  null
  
)

export default component.exports